import styled from 'styled-components';

export const Container = styled.div`
  h5 {
    color: ${(props) => props.theme.$gray900};
    font-size: 16px;
  }
  label {
    color: ${(props) => props.theme.$gray900};
    font-weight: 500 !important;
  }
`;
